import jsonFetch from '../utilities/jsonFetch.js';
import getAppRoot from '../utilities/getAppRoot.js';

export default {
  completeForgotPassword: async ({
    password,
    requestVerificationToken,
    token,
  }) => {
    return await jsonFetch({
      body: {
        password,
      },
      headers: {'RequestVerificationToken': requestVerificationToken},
      method: 'POST',
      url: `/${getAppRoot()}/recover/password/${token}`
    });
  },

  startForgotPassword: async (username, token, captcha) => {
    return await jsonFetch({
      body: {
        username
      },
      headers: {
        'RequestVerificationToken': token,
        'X-Captcha-Token': captcha
      },
      method: 'POST',
      url: `/${getAppRoot()}/recover/password`
    });
  },

};